import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { FinyearService, WorkOrderService } from "../../../services/index";
import { WhWorkOrderService } from "../../../services/whWorkOrder.service";

@Component({
  selector: "whWorkOrder",
  templateUrl: "./whWorkOrder.html",
})
export class whWorkOrder implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  list: any[];
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter: any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "order_from",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];
  selected = [];
  filterExpand = false;

  agentList$ = [];
  companyInfo: any = [];
  finyearCtrl: FormControl = new FormControl();
  finyearList = [];
  constructor(
    private finyearService: FinyearService,
    public store: Store<fromRootStore.State>,
    private Woservice: WorkOrderService,
    private whWorkOrderService: WhWorkOrderService,
    public toasterService: ToasterService
  ) {
    this.filter = {
      type: "",
      party: '',
      date: '',
      designNo: ''
    };
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;*/
  }

  ngOnInit(): void {
    this.columns = [
      {
        name: "S.No",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "WO No",
        prop: "wh_wo_id",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Date",
        prop: "date",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        name: "Type",
        prop: "type",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Party",
        prop: "party_name",
        minWidth: 350,
        maxWidth: 350,
        width: 350,
      },
      {
        name: "Design No",
        prop: "design_no",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        name: "Assigned Qty",
        prop: "assigned_qty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        cellClass: "text-right",
      },
      // { name: 'Action', prop: 'sno', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
    ];

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getList();
  }

  getList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 0)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      ...this.filter
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.whWorkOrderService
      .getWhWorkOrderList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.list = res.data;

      });
  }

  clearFilter(): void {
    this.filter = {
      type: "",
      party: '',
      date: '',
      designNo: '',
    };
    this.applyFilter();
  }

  applyFilter(): void {
    // this.filterPanel.close();
    this.getList();
  }

  goToAddEdit(mode: 'ADD' | 'EDIT', row: any): void {
    const listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getList();
    });

    row.tabevent = listUpdateEvent;

    const tabLabel = `${mode} WH WORK ORDER`;
    console.log("tabLabel :: ", tabLabel);

    const tabObj = {
      action: "NewTab",
      params: {
        tabName: tabLabel,
        title: tabLabel,
        tabParent: "BAGGIING & RACKING PROCESS_TRANSACTION",
        mode,
        data: row,
        name: tabLabel,
      },
    };

    this.tabUpdateEvent.emit(tabObj);
  }

  onSelect({ selected }, ind) {

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  deleteRackDetails(row): void {

    let params = {
      requestId: row.id
    };
    let that = this;
    swal({
      title: "Are you sure to delete",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.Woservice
          .deleteRackAllocateDetails(params)
          .then(function (res: any) {
            that.loadingIndicator = false;

            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }
            else {
              that.getList();
            }
            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        /*if (dismiss === 'cancel') {
              swal(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              )
            }*/
      }
    );
  }

  addEditDetails(mode: string): void {
    let row = {
      sp_id: 1,
      fin_id: 1,
      sales_target: 4000,
      order_per: 50,
      order_target: 8000,
      fin_year: "2015-2016",
    };
    let tabObj = {
      action: "NewTab",
      params: {
        tabParent: "Master",
        tabName: "PlandetailsMasterComponent",
        mode: mode,
        data: row,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/phase1/WhWorkOrder/whWorkOrder.ts